export default "__VITE_ASSET__BfJK0gK0__"